import { DatePipe } from '@angular/common';
import { Component,Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
// import { ToastrService } from 'ngx-toastr';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DashboarduiService } from 'src/app/components/Shared/Service/dashboardui.service';
import { LocalstorageService } from 'src/app/components/Shared/Service/localstorage.service';
declare var $: any; 
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: any;
  status: any;
  // hotelName: any;
  accountingDate: any;
  pusheddate: any;
  type:any
}
@Component({
  selector: 'app-hotel-multiple-cmcrs',
  templateUrl: './hotel-multiple-cmcrs.component.html',
  styleUrls: ['./hotel-multiple-cmcrs.component.css'],
  providers: [DashboarduiService,
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class HotelMultipleCmcrsComponent {
  // @Input() TechURL:any;
  // @Input() UserURL:any;
  searchText:any;
  typ:any;
  public PGF: any = "0";
  public PGT: any = "50";
  pageSize = 50;
  pageSizeOptions: number[] = [5, 10, 250, 500];
  isIDSUser: any;
  apiresult: any;
  hotellistChannel: any;
  
  url: any;
  maxDate: Date;
    pmscode: any;
    hotelName: any;
    islive: any;
    cancelURL: any;
    createURL: any;
    updateURL: any;
    UserId: any;
    flag: any;
    storeDelRec: any;
  storeEventValue: any;
  filterProperty: any;
  // private toastr: ToastrService,
  constructor(public router:Router,private apiCallIdsService: DashboarduiService, private datePipe: DatePipe, private localStorage: LocalstorageService) { 
    this.maxDate = new Date(this.today.setDate(this.today.getDate()));
  }
  
  today = new Date();
  today1:any= new Date();
  selectedDate: any= new Date(this.today.setDate(this.today.getDate() - 1));
  selectedTOODate: any= new Date(this.today1.setDate(this.today1.getDate() - 1));
  display: Boolean = false;
  totalcount: any = 0;
  hotellistCopy: any = [];
  idsProductList: idsProductList[] = [];
  dataSource!: MatTableDataSource<idsProductList>;
  StorelstRestr: any;
  // lstidsProductList:any;
  // dataSource:any;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true })
  sort!: MatSort;
  Val: any;
  selectedProperty: any;
  selectedChannel: any;
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  selected: any;
  Userid: any = [];
  displayedColumns: string[] = ['SNO','HotelName','cmcode','createdatetime'];
  ngOnInit() {
    // console.log( this.url)
    this.isProgressing = true;
    // setTimeout(()=>{
      this.callSyncHotelList();
  }
  
  callSyncHotelList(){
    this.apiCallIdsService.hotelDataWithMultCMCRS()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          this.idsProductList=data;
          this.filterProperty = this.idsProductList
          this.dataSource = new MatTableDataSource(this.idsProductList);
          this.dataSource.paginator = this.paginator;
          this.isProgressing=false;
        },
        );
  }

  pageEvent(e:any) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } 
  Search(event:any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { hotelInfo: { toString: () => string; }}) => {
      return res.hotelInfo.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    });
    if(event == ''){
      this.Val = '';
      // this.isProgressing = true
      this.callSyncHotelList();
    }
  }

  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }
}

